import React, { useState, Fragment, useEffect, useMemo } from "react";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";
import {
  editMember,
  getShgMembersFamily,
  addNewFamilyDetails,
  getShgMembersFamilyOccupation,
  getOcccupationsDropdown,
  getSubOccupation,
  getBatchInfo,
} from "../../actions/shg";
import EditFamilyMember from "./EditFamilyMember";
import Spinner from "../layout/Spinner";
import { Modal } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
// import Autocomplete from "./Autocomplete";
import GovtCards from "./GovtCards.js";
import {
  getReligions,
  getCaste,
  getSubcasteDetails,
} from "../../actions/religionSetting";

const EditMemberDetails = ({
  auth: { isAuthenticated, user, users, loading },
  shg: {
    membersFamily,
    membersFamilyOccupation,
    activeOccupation,
    getAllSubOccupation,
  },
  religionSetting: { religionsData, activeCaste, getSubcaste },
  editMember,
  getSubOccupation,
  onUpdateModalChange,
  getShgMembersFamily,
  addNewFamilyDetails,
  // getShgMembersFamilyOccupation,
  getOcccupationsDropdown,
  getSubcasteDetails,
  getCaste,
  getReligions,
  getBatchInfo,
  // membersdata,
}) => {
  // const finalData = {
  //   batchId: selBatchId.batchId,
  // };
  // getBatchInfo(finalData);

  let loggedUserInstitutionData = JSON.parse(
    localStorage.getItem("loggedUserInstitutionData"),
  );
  let addBatchInfo = JSON.parse(localStorage.getItem("selBatchInfo"));
  let membersdata = JSON.parse(localStorage.getItem("membersdata"));

  useEffect(() => {
    getShgMembersFamily({
      memberIdVal: membersdata._id ? membersdata._id : null,
    });
  }, [getShgMembersFamily]);
  useEffect(() => {
    getOcccupationsDropdown();
  }, [getOcccupationsDropdown]);
  useEffect(() => {
    getReligions();
  }, [getReligions]);
  useEffect(() => {
    getCaste({
      religionInfo: membersdata.memberReligionId
        ? membersdata.memberReligionId
        : null,
    });
  }, [getCaste]);
  useEffect(() => {
    getSubcasteDetails({
      cIdVal: membersdata.memberCasteId ? membersdata.memberCasteId : null,
    });
  }, [getSubcasteDetails]);

  useEffect(() => {
    getSubOccupation({
      occupationInfo: membersdata.memberOcupationId || null,
    });
    getBatchInfo({
      batchId: membersdata.batchId,
    });
  }, []);

  const allPermission = useMemo(() => {
    if (
      loggedUserInstitutionData &&
      Array.isArray(loggedUserInstitutionData.permission)
    ) {
      return loggedUserInstitutionData.permission.map(
        (permission) => permission.permissionName,
      );
    }
    return [];
  }, [loggedUserInstitutionData]);

  // const allAccess = useMemo(() => {
  //   if (
  //     loggedUserInstitutionData &&
  //     Array.isArray(loggedUserInstitutionData.access)
  //   ) {
  //     return loggedUserInstitutionData.access.map(
  //       (access) => access.accessName,
  //     );
  //   }
  //   return [];
  // }, [loggedUserInstitutionData]);

  // const allOccupation = [];
  // membersFamilyOccupation &&
  //   membersFamilyOccupation.map((occupation) => {
  //     if (occupation.familyMembers.familyMemberOcupation)
  //       allOccupation.push(occupation.familyMembers.familyMemberOcupation);
  //   });
  // code for next previous tabing starts
  const [tabIndex, setTabIndex] = useState(0);
  const NextBackBtn = (e, tabIndex) => {
    e.preventDefault();
    if (checkErrors()) {
      setTabIndex(tabIndex);
    }
  };
  const RationCardMethods = [
    { value: "BPL", label: "BPL" },
    { value: "APL", label: "APL" },
    { value: "AAP", label: "AAP" },
    { value: "PHH", label: "PHH" },
    { value: "AAY", label: "AAY" },
  ];
  const GenderOpt = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];
  const MemDesigMethods = [
    { value: "Member", label: "Member" },
    { value: "Secretary", label: "Secretary" },
    { value: "Treasurer", label: "Treasurer" },
    { value: "President", label: "President" },
    { value: "Representative", label: "Representative" },
    { value: "Animator", label: "Animator" },
    { value: "Children", label: "Children" },
    { value: "Student", label: "Student" },
    { value: "Normal employee", label: "Normal employee" },
    { value: "Volunteer ", label: "Volunteer " },
  ];
  const MemMaritalStatus = [
    { value: "Married", label: "Married" },
    { value: "Unmarried", label: "Unmarried" },
    { value: "Widow", label: "Widow" },
    { value: "Single", label: "Single" },
    { value: "Separated", label: "Separated" },
    { value: "Abandoned", label: "Abandoned" },
    { value: "other", label: "other" },
  ];
  const EducationOpt = [
    { value: "Primary", label: "Primary" },
    { value: "Higher primary", label: "Higher primary" },
    { value: "High School", label: "High School" },
    { value: "PUC", label: "PUC" },
    { value: "Degree", label: "Degree" },
    { value: "PG", label: "PG" },
    { value: "Uneducated", label: "Uneducated" },
    { value: "Others", label: "Others" },
  ];
  const MemDisabilityList = [
    { value: "Blindness", label: "Blindness", DlId: "DL01" },
    { value: "Low-vision", label: "Low-vision", DlId: "DL02" },
    {
      value: "Leprosy Cured persons",
      label: "Leprosy Cured persons",
      DlId: "DL03",
    },
    {
      value: "Hearing Impairment (deaf and hard of hearing)",
      label: "Hearing Impairment (deaf and hard of hearing)",
      DlId: "DL04",
    },
    {
      value: "Locomotor Disability",
      label: "Locomotor Disability",
      DlId: "DL05",
    },
    { value: "Dwarfism", label: "Dwarfism", DlId: "DL06" },
    {
      value: "Intellectual Disability",
      label: "Intellectual Disability",
      DlId: "DL07",
    },
    { value: "Mental Illness", label: "Mental Illness", DlId: "DL08" },
    {
      value: "Autism Spectrum Disorder",
      label: "Autism Spectrum Disorder",
      DlId: "DL09",
    },
    { value: "Cerebral Palsy", label: "Cerebral Palsy", DlId: "DL10" },
    { value: "Muscular Dystrophy", label: "Muscular Dystrophy", DlId: "DL11" },
    {
      value: "Chronic Neurological conditions",
      label: "Chronic Neurological conditions",
      DlId: "DL12",
    },
    {
      value: "Specific Learning Disabilities",
      label: "Specific Learning Disabilities",
      DlId: "DL13",
    },
    { value: "Multiple Sclerosis", label: "Multiple Sclerosis", DlId: "DL14" },
    {
      value: "Speech and Language disability",
      label: "Speech and Language disability",
      DlId: "DL15",
    },
    { value: "Thalassemia", label: "Thalassemia", DlId: "DL16" },
    { value: "Hemophilia", label: "Hemophilia", DlId: "DL17" },
    {
      value: "Sickle Cell disease",
      label: "Sickle Cell disease",
      DlId: "DL18",
    },
    {
      value: "Multiple Disabilities including deafblindness",
      label: "Multiple Disabilities including deafblindness",
      DlId: "DL19",
    },
    { value: "Acid Attack victim", label: "Acid Attack victim", DlId: "DL20" },
    {
      value: "Parkinson's disease",
      label: "Parkinson's disease",
      DlId: "DL21",
    },
  ];
  const HealthVulnerability = [
    { value: "None", label: "None" },
    { value: "Disabled", label: "Disabled" },
    { value: "Chronic Sickness", label: "Chronic Sickness" },
    {
      value: "Sick or Disabled in Family",
      label: "Sick or Disabled in Family",
    },
    { value: "Other", label: "Other" },
  ];
  const [showHide, setShowHide] = useState({
    showotherEducationSection:
      membersdata && membersdata.memberEducation === "Others" ? true : false,
    showmaritalothstatus:
      membersdata && membersdata.memberMaritalStatus === "other" ? true : false,
  });
  const { showotherEducationSection, showmaritalothstatus } = showHide;
  const [showFamHide, setFamShowHide] = useState({
    showFamOtherEducationSection: false,
  });
  const { showFamOtherEducationSection } = showFamHide;
  // let memberMaritalStatus1 ="",
  // if (allPermission && allPermission.includes("MemberPermission_AWAKE")) {
  //   memberMaritalStatus1:membersdata && membersdata.memberMaritalStatus
  //   ? {
  //       value: membersdata.memberMaritalStatus,
  //       label: membersdata.memberMaritalStatus,
  //     }
  //   : "",
  // }else{
  //   memberMaritalStatus1:
  //       membersdata && membersdata.memberMaritalStatus
  //         ? membersdata.memberMaritalStatus
  //       : "",
  // }
  const [showAlertMsg, setshowAlertMsg] = useState(false);
  const onUpdateALertMsg = () => {
    setshowAlertMsg(false);
  };

  //formData
  const [formData, setFormData] = useState({
    memberName:
      membersdata && membersdata.memberName ? membersdata.memberName : "",
    batchName:
      membersdata && membersdata.batchName ? membersdata.batchName : "",
    // batchFormationDate:membersdata && membersdata.batchFormationDate ? membersdata.batchFormationDate:"",
    memberPhone:
      membersdata && membersdata.memberPhone ? membersdata.memberPhone : "",
    memberAddress:
      membersdata && membersdata.memberAddress ? membersdata.memberAddress : "",
    memberContactPersonName:
      membersdata && membersdata.memberContactPersonName
        ? membersdata.memberContactPersonName
        : "",
    memberMaritalStatus:
      membersdata && membersdata.memberMaritalStatus
        ? {
            value: membersdata.memberMaritalStatus,
            label: membersdata.memberMaritalStatus,
          }
        : "",
    memberMonthlyIncome:
      membersdata && membersdata.memberMonthlyIncome
        ? membersdata.memberMonthlyIncome
        : "",
    memberAnnualIncome:
      membersdata && membersdata.memberAnnualIncome
        ? membersdata.memberAnnualIncome
        : "",
    memberVocationalSkill:
      membersdata && membersdata.memberVocationalSkill
        ? membersdata.memberVocationalSkill
        : "",
    memberAadharNo:
      membersdata && membersdata.memberAadharNo
        ? membersdata.memberAadharNo
        : "",
    memberPanNo:
      membersdata && membersdata.memberPanNo ? membersdata.memberPanNo : "",
    memberUdidNo: membersdata && membersdata.udidNo ? membersdata.udidNo : "",
    otherStatus:
      membersdata && membersdata.otherStatus ? membersdata.otherStatus : " ",
    memberDisabilityType:
      membersdata && membersdata.memberDisabilityType
        ? {
            value: membersdata.memberDisabilityType,
            label: membersdata.memberDisabilityType,
          }
        : "",
    memberDOB:
      membersdata && membersdata.memberDOB ? membersdata.memberDOB : "",
    memberAge:
      membersdata && membersdata.memberDOB
        ? Math.abs(
            new Date(
              Date.now() - new Date(membersdata.memberDOB).getTime(),
            ).getUTCFullYear() - 1970,
          )
        : 0,
    guardianName:
      membersdata && membersdata.guardianInfo ? membersdata.guardianInfo : "",
    memberReligion:
      membersdata && membersdata.memberReligion
        ? membersdata.memberReligion
        : "",
    startSelectedDate:
      membersdata && membersdata.memberJoiningDate
        ? membersdata.memberJoiningDate
        : "",
    memberCode:
      membersdata && membersdata.memberCode ? membersdata.memberCode : "",
    memberOcupationId:
      membersdata && membersdata.memberOcupationId
        ? membersdata.memberOcupationId
        : "",
    memberOcupation:
      membersdata && membersdata.memberOcupation
        ? membersdata.memberOcupation
        : "",
    memberSubOccupationId:
      membersdata && membersdata.memberSubOccupationId
        ? membersdata.memberSubOccupationId
        : "",
    memberSubOccupation:
      membersdata && membersdata.memberSubOccupation
        ? membersdata.memberSubOccupation
        : "",
    memberDesg:
      membersdata && membersdata.memberDesg
        ? {
            value: membersdata.memberDesg,
            label: membersdata.memberDesg,
          }
        : "",
    memberEducation:
      membersdata && membersdata.memberEducation
        ? {
            value: membersdata.memberEducation,
            label: membersdata.memberEducation,
          }
        : "",
    otherEducation:
      membersdata && membersdata.otherEducation
        ? membersdata.otherEducation
        : "",
    memberGender:
      membersdata && membersdata.memberGender
        ? {
            value: membersdata.memberGender,
            label: membersdata.memberGender,
          }
        : "",
    rationCardType:
      membersdata && membersdata.rationCardType
        ? {
            value: membersdata.rationCardType,
            label: membersdata.rationCardType,
          }
        : "",
    healthVulnerabilityType:
      membersdata && membersdata.healthVulnerabilityType
        ? {
            value: membersdata.healthVulnerabilityType,
            label: membersdata.healthVulnerabilityType,
          }
        : "",
    isSubmitted: false,
  });
  const {
    batchName,
    // batchFormationDate,
    memberName,
    memberPhone,
    memberAddress,
    memberAadharNo,
    rationCardType,
    healthVulnerabilityType,
    memberPanNo,
    memberUdidNo,
    otherStatus,
    memberDisabilityType,
    memberDOB,
    memberAge,
    guardianName,
    memberDesg,
    memberEducation,
    otherEducation,
    memberJoiningDate,
    memberGender,
    memberReligion,
    memberCode,
    memberOcupationId,
    memberOcupation,
    // memberSubOccupationId,
    // memberSubOccupation,
    memberContactPersonName,
    memberMaritalStatus,
    memberMonthlyIncome,
    memberAnnualIncome,
    memberVocationalSkill,
    isSubmitted,
  } = formData;
  const [addData, setFormDatas] = useState({
    familyMemberName: "",
    familyMemberAge: "",
    familyMemberPhone: "",
    familyMemberGender: "",
    familyMemberRelationship: "",
    otherFamilyEducation: "",
    familyMemberMaritalStatus: "",
    familyMemberEducation: "",
    familyMemberOcupation: "",
    familyMemberSubOccupation: "",
    familyMemberMonthlyIncome: "",
    familyMemberAnnualIncome: "",
    familyMemberDisabilityType: "",
    familyMemberDisabilityId: "",
    familyUdidNo: "",
  });
  const {
    familyMemberName,
    familyMemberAge,
    familyMemberPhone,
    familyMemberGender,
    familyMemberRelationship,
    familyMemberMaritalStatus,
    familyMemberEducation,
    otherFamilyEducation,
    familyMemberOcupation,
    familyMemberSubOccupation,
    familyMemberMonthlyIncome,
    familyMemberAnnualIncome,
    familyMemberDisabilityId,
    familyMemberDisabilityType,
    familyUdidNo,
  } = addData;
  const onInputChange1 = (e) => {
    setFormDatas({ ...addData, [e.target.name]: e.target.value });
  };
  const onFamilyMemberGenderChange = (e) => {
    if (e) {
      setFormDatas({ ...addData, familyMemberGender: e });
    }
  };
  const handleOnFamilyChange = () => {
    setFamilyDisabilitiesChecker(!familyDisabilitiesChecker);
    if (!familyDisabilitiesChecker) {
      setFormDatas({
        ...addData,
        familyMemberDisabilityType: "",
        familyUdidNo: "",
      });
    }
  };
  const onFammemberEducationChange = (e) => {
    if (e) {
      setFormDatas({
        ...addData,
        familyMemberEducation: e,
      });
    }
    if (e.value === "Others") {
      setFamShowHide({
        ...showFamHide,
        showFamOtherEducationSection: true,
      });
    } else {
      setFamShowHide({
        ...showFamHide,
        showFamOtherEducationSection: false,
      });
    }
  };
  // const [occ, setOcc] = useState("");
  const [AddedDetails, AddDetails] = useState([]);
  const onAdd = (e) => {
    const familyMemberList = AddedDetails.filter(
      (AddDetails) => AddDetails.familyMemberName === familyMemberName,
    );
    e.preventDefault();
    let famMemLen =
      membersFamily.familyMembers &&
      membersFamily.familyMembers.length + AddedDetails.length;
    if (familyMemberList.length === 0 && famMemLen < 8) {
      if (addData && addData.familyMemberName) {
        const addData = {
          recordId: membersdata && membersdata._id,
          familyMemberName: familyMemberName,
          familyMemberAge: familyMemberAge,
          familyMemberPhone: familyMemberPhone,
          familyMemberGender: familyMemberGender.value,
          familyMemberRelationship: familyMemberRelationship,
          familyMemberMaritalStatus: familyMemberMaritalStatus,
          familyMemberEducation: familyMemberEducation.value,
          otherFamilyEducation: otherFamilyEducation
            ? otherFamilyEducation
            : "",
          familyMemberOcupationId: occupationId,
          familyMemberOcupation: occupationName,
          familyMemberSubOccupationId: familySubOccupationId,
          familyMemberSubOccupation: familySubOccupationName,
          familyMemberMonthlyIncome: familyMemberMonthlyIncome,
          familyMemberAnnualIncome: anualIncomeVal,
          isFamDisable: familyDisabilitiesChecker,
          familyMemberDisabilityId: familyMemberDisabilityId,
          familyMemberDisabilityType: familyMemberDisabilityType.value,
          familyUdidNo: familyUdidNo,
          familyCards: SelectedCardsFamily,
          familyMemberReligionId: familyReligionId,
          familyMemberReligion: familyReligionName,
          familyMemberCasteId: familyCasteId,
          familyMemberCaste: familyCasteName,
          familyMemberSubCasteId: familySubCasteId,
          familyMemberSubCaste: familySubCasteName,
        };
        setFormDatas({
          ...addData,
          familyMemberName: "",
          familyMemberAge: "",
          familyMemberPhone: "",
          familyMemberGender: "",
          familyMemberRelationship: "",
          familyMemberMaritalStatus: "",
          familyMemberEducation: "",
          otherFamilyEducation: "",
          familyMemberOcupationId: "",
          familyMemberOcupation: "",
          familyMemberSubOccupationId: "",
          familyMemberSubOccupation: "",
          familyMemberMonthlyIncome: "",
          familyMemberAnnualIncome: "",
          familyMemberDisabilityId: "",
          familyMemberDisabilityType: "",
          familyUdidNo: "",
        });
        let temp = [];
        temp.push(...AddedDetails, addData);
        getOccupationData("");
        setOccupationID(null);
        setOccupationName("");
        setFamilySubOccupationData("");
        setFamilySubOccupationID(null);
        setFamilySubOccupationName("");
        getFamilyReligionData("");
        setFamilyReligionID(null);
        setFamilyReligionName("");
        getFamilyCasteData("");
        setFamilyCasteID(null);
        setFamilyCasteName("");
        setFamilySubCaste("");
        setFamilySubCasteID(null);
        setFamilySubCasteName("");
        setFamilyDisabilitiesChecker(false);
        AddDetails(temp);
        setSelectedCardsFamily([]);
        // setOcc("");
      }
    }
  };
  const onRemoveChange = (familyMemberName) => {
    const removeList = AddedDetails.filter(
      (AddDetails) => AddDetails.familyMemberName !== familyMemberName,
    );
    AddDetails(removeList);
  };

  let anualIncomeVal = 0;
  anualIncomeVal = familyMemberMonthlyIncome * 12;
  let anualmemIncomeVal = 0;
  anualmemIncomeVal = memberMonthlyIncome * 12;
  const [selectionType1, setSelectionType1] = useState();
  if (!selectionType1 && membersdata && membersdata.memberGender) {
    setSelectionType1(membersdata.memberGender);
  }
  const onRadioGenderChange = (e) => {
    // setSelectionType1(e);
    setFormData({ ...formData, memberGender: e });
  };
  const [disabilitiesChecker, setDisabilitiesChecker] = useState(
    membersdata && membersdata.isDisable ? membersdata.isDisable : false,
  );
  const [familyDisabilitiesChecker, setFamilyDisabilitiesChecker] =
    useState(false);
  const handleOnChange = () => {
    setDisabilitiesChecker(!disabilitiesChecker);
  };
  const onFamDisabilityChange = (e) => {
    if (e) {
      setFormDatas({
        ...addData,
        familyMemberDisabilityType: e,
        familyMemberDisabilityId: e.DlId,
      });
      // setError({
      //   ...error,
      //   DisabilityTypeErrorStyle: { color: "#000" },
      // });
    }
  };
  const [showothmaritalstatus, setshowothmaritalstatus] = useState({
    showmaritalothstatus: false,
  });
  const [MemberMaritalStatus, setMaritalStatus] = useState();
  //  const {showmaritalothstatus}=showothmaritalstatus;

  // if (membersdata && membersdata.memberMaritalStatus) {
  //   if (membersdata && membersdata.memberMaritalStatus === "other") {
  //     setShowHide({
  //       ...showHide,
  //       showmaritalothstatus:true,
  //     });
  //   } else {
  //     setShowHide({
  //       ...showHide,
  //       showmaritalothstatus: false,
  //     });
  //   }
  // }

  const [showEditModal, setShowEditModal] = useState(false);
  const [userFamMembersData, setUserFamMembersData] = useState(null);
  const handleEditModalClose = () => setShowEditModal(false);
  const onUpdateFamilyDetails = (famMembers, idx) => {
    setShowEditModal(true);
    setUserFamMembersData(famMembers);
  };
  const onEditModalChange = (e) => {
    if (e) {
      handleEditModalClose();
    }
  };
  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [startSelectedDate, setMemberjoinDate] = useState(
    membersdata.memberJoiningDate,
  );

  const onDateChange = (e) => {
    var bFormationDate = addBatchInfo[0].batchFormationDate;

    var currentDate = e.target.value;
    // setMemberjoinDate(e.target.value);
    if (currentDate < bFormationDate) {
      if (Number(e.target.value.split("-")[0].split("")[0]) > 0) {
        setshowAlertMsg(true);
      }
      setMemberjoinDate(e.target.value);
    } else {
      setMemberjoinDate(e.target.value);
    }
  };
  const onDateChangeDOB = (e) => {
    var age_dt = new Date(Date.now() - new Date(e.target.value).getTime());
    setFormData({
      ...formData,
      memberDOB: e.target.value,
      memberAge: Math.abs(age_dt.getUTCFullYear() - 1970),
    });
  };
  const onMemDesigChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        memberDesg: e,
      });
    }
  };

  // if(allPermission && allPermission.includes("MemberPermission_AWAKE")){alert("")}
  const onMaritalStatusChange = (e) => {
    setMaritalStatus(e);
    let maritalstatus = {
      label: e.label,
      value: e.value,
    };
    setFormData({
      ...formData,
      memberMaritalStatus: maritalstatus,
    });
    if (e) {
      setFormData({
        ...formData,
        memberMaritalStatus: e,
      });
    }
    if (e.value === "other") {
      setShowHide({
        ...showHide,
        showmaritalothstatus: true,
      });
    } else {
      setShowHide({
        ...showHide,
        showmaritalothstatus: false,
      });
      // setFormData({
      //   ...formData,
      //   otherStatus: "",
      // });
    }
  };
  const onMemmemberEducationChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        memberEducation: e,
      });
    }
    if (e.value === "Others") {
      setShowHide({
        ...showHide,
        showotherEducationSection: true,
      });
    } else {
      setShowHide({
        ...showHide,
        showotherEducationSection: false,
      });
    }
  };
  // if (membersdata && membersdata.otherEducation) {
  //   if (membersdata.otherEducation.value === "Others") {
  //     setShowHide({
  //       ...showHide,
  //       showotherEducationSection: true,
  //     });
  //   } else {
  //     setShowHide({
  //       ...showHide,
  //       showotherEducationSection: false,
  //     });
  //   }
  // }
  const onMemDisabilityChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        memberDisabilityType: e,
      });
      setError({
        ...error,
        DisabilityTypeErrorStyle: { color: "#000" },
      });
    }
  };
  //Required Validation Starts
  const [error, setError] = useState({
    // DesgIdChecker: false,
    // DesgErrorStyle: {},
    memberNameChecker: false,
    MemErrorStyle: {},
     phoneError:{},
    phoneNumberChecker:false,
    adharNumChecker: false,
    adharErrorStyle: {},
    UDIDNumberErrorStyle: {},
    DisabilityTypeErrorStyle: {},
    guardianNameErrorStyle: {},
  });
  // const { DesgIdChecker, DesgErrorStyle } = error;
  const {
    memberNameChecker,
    MemErrorStyle,
    adharNumChecker,
    phoneError,
    adharErrorStyle,
    UDIDNumberErrorStyle,
    DisabilityTypeErrorStyle,
    guardianNameErrorStyle,
  } = error;
  const checkErrors = () => {
    // if (!DesgIdChecker) {
    //   setError({
    //     ...error,
    //     DesgErrorStyle: { color: "#F00" },
    //   });
    //   return false;
    // }
    if (!memberName) {
      setError({
        ...error,
        MemErrorStyle: { color: "#F00" },
      });
      return false;
    } else {
      setError({
        ...error,
        memberNameChecker: true,
        MemErrorStyle: { color: "#000" },
      });
    }
    if (!memberPhone) {
      setError({
        ...error,
        phoneError: { color: "#F00" },
      });
      return false;
    }
    if (allPermission && allPermission.includes("AadharNumber")) {
      if (!memberAadharNo) {
        setError({
          ...error,
          adharErrorStyle: { color: "#F00" },
        });
        return false;
      } else {
        setError({
          ...error,
          adharNumChecker: true,
          adharErrorStyle: { color: "#000" },
        });
      }
    }
    if (disabilitiesChecker === true) {
      if (!memberUdidNo) {
        setError({
          ...error,
          UDIDNumberErrorStyle: { color: "#F00" },
        });
        return false;
      }
      if (!memberDisabilityType) {
        setError({
          ...error,
          DisabilityTypeErrorStyle: { color: "#F00" },
        });
        return false;
      }
    }
    if (memberAge < 18 && memberAge !== 0 && !guardianName) {
      setError({
        ...error,
        guardianNameErrorStyle: { color: "#F00" },
      });
      return false;
    }
    return true;
  };
  const onrationCardTypeChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        rationCardType: e,
      });
    }
  };
  const onHealthVulnerabilityTypeChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        healthVulnerabilityType: e,
      });
    }
  };
  const [occupation, getOccupationData] = useState();
  const [occupationId, setOccupationID] = useState();
  const [occupationName, setOccupationName] = useState();
  const allOccupation = useMemo(() => {
    if (!Array.isArray(activeOccupation)) return [];
    return activeOccupation.map((occupation) => ({
      oId: occupation._id,
      label: occupation.occcupationName,
      value: occupation.occcupationName,
    }));
  }, [activeOccupation]);

  const [memberOccupation, getMemberOccupationData] = useState();
  const [memberOccupationId, setMemberOccupationId] = useState(
    membersdata.memberOcupationId,
  );
  const [memberOccupationName, setMemberOccupationName] = useState(
    membersdata.memberOcupation,
  );
  if (
    !memberOccupation &&
    membersdata.memberOcupationId &&
    allOccupation.length > 0
  ) {
    getMemberOccupationData(
      membersdata
        ? allOccupation &&
            allOccupation.filter(
              (x) => x.oId === membersdata.memberOcupationId,
            )[0]
        : "",
    );
  }
  const [familySubOccupation, setFamilySubOccupationData] = useState();
  const [familySubOccupationId, setFamilySubOccupationID] = useState();
  const [familySubOccupationName, setFamilySubOccupationName] = useState();
  const onFamilySubOccupationChange = (e) => {
    setFamilySubOccupationData(e);
    setFamilySubOccupationID(e.subOccupationId ? e.subOccupationId : null);
    setFamilySubOccupationName(e.value ? e.value : "");
  };
  const funcKeyDown = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  };
  const onOccupationChange = (e) => {
    getOccupationData(e);
    setOccupationID(e.oId ? e.oId : null);
    setOccupationName(e.value ? e.value : "");
    getSubOccupation({
      occupationInfo: e.oId,
    });
  };
  const [membersubOccupation, setSubOccupation] = useState();
  const onMemberOccupationChange = (e) => {
    getMemberOccupationData(e);
    setMemberOccupationId(e.oId ? e.oId : null);
    setMemberOccupationName(e.value ? e.value : "");
    setSubOccupation("");
    setSubOccupationID("");
    setSubOccupationName("");
    getSubOccupation({
      occupationInfo: e.oId,
    });
  };
  const onUpdate = (e) => {
    e.preventDefault();
    if (checkErrors()) {
      const finalData = {
        recordId: membersdata ? membersdata._id : "",
        memberName: memberName,
        memberPhone: memberPhone,
        memberAddress: memberAddress,
        memberAadharNo: memberAadharNo,
        memberPanNo: memberPanNo,
        rationCardType: rationCardType.value,
        healthVulnerabilityType: healthVulnerabilityType.value,
        memberDesg: memberDesg.value,
        memberGender: memberGender.value,
        memberJoiningDate: startSelectedDate,
        memberCode: memberCode,
        memberReligionId: religionId,
        memberReligion: religionName,
        memberCasteId: casteId,
        memberCaste: casteName,
        memberSubCasteId: subCasteId,
        memberSubCaste: subCasteName,
        isDisable: disabilitiesChecker,
        udidNo: memberUdidNo,
        otherStatus: otherStatus,
        memberOcupationId: memberOccupationId,
        memberOcupation: memberOccupationName,
        memberSubOccupationId: memberSubOccupationId,
        memberSubOccupationName: memberSubOccupationName,
        memberDisabilityType: memberDisabilityType.value,
        memberDOB: memberDOB,
        guardianInfo: guardianName,
        memberEducation:
          memberEducation && memberEducation ? memberEducation.value : "",
        otherEducation:
          otherEducation &&
          memberEducation &&
          memberEducation.value === "Others"
            ? otherEducation
            : "",
        cards: SelectedCards,
        memberContactPersonName: memberContactPersonName,
        memberMaritalStatus: memberMaritalStatus.value
          ? memberMaritalStatus.value
          : memberMaritalStatus,
        memberMonthlyIncome: memberMonthlyIncome,
        memberAnnualIncome: anualmemIncomeVal,
        memberVocationalSkill: memberVocationalSkill,
      };
      // console.log("finl", finalData);
      editMember(finalData);
      for (let i = 0; i < AddedDetails.length; i++) {
        addNewFamilyDetails(AddedDetails[i]);
      }
      setFormData({
        ...formData,
        isSubmitted: true,
      });
    }
  };
  //GOVT CARDS
  const [SelectedCards, setSelectedCards] = useState(
    membersdata && membersdata.cards ? membersdata.cards : [],
  );
  const [showCardsModal, setshowCardsModal] = useState(false);
  const handleCardsModalClose = () => setshowCardsModal(false);
  const onClickHandler = () => {
    setshowCardsModal(true);
  };
  //FAMILY
  const [SelectedCardsFamily, setSelectedCardsFamily] = useState([]);
  const [showCardsFamilyModal, setshowCardsFamilyModal] = useState(false);
  const handleCardsFamilyModalClose = () => setshowCardsFamilyModal(false);
  const onFamilyClickHandler = () => {
    setshowCardsFamilyModal(true);
  };
  //GOVT CARDS END
  //CASTE RELIGION START
  const allReligionsData = useMemo(() => {
    const data = [];
    religionsData.map((religion) =>
      data.push({
        rId: religion._id,
        label: religion.religionName,
        value: religion.religionName,
      }),
    );
    return data;
  }, [religionsData]);

  const [religion, getReligionData] = useState();
  if (
    !religion &&
    membersdata.memberReligionId &&
    allReligionsData.length > 0
  ) {
    getReligionData(
      membersdata
        ? allReligionsData &&
            allReligionsData.filter(
              (x) => x.rId === membersdata.memberReligionId,
            )[0]
        : "",
    );
  }
  const [religionId, setReligionID] = useState(membersdata.memberReligionId);
  const [religionName, setReligionName] = useState(membersdata.memberReligion);
  const onReligionChange = (e) => {
    getReligionData(e);
    setReligionID(e.rId ? e.rId : null);
    setReligionName(e.value ? e.value : "");
    getCaste({
      religionInfo: e.rId,
    });
    //getCasteData("");
    // setCasteID(null);
    //setCasteName("");
    //setSubCaste("");
    //setSubCasteID(null);
    //setSubCasteName("");
  };
  const allCasteData = useMemo(() => {
    const data = [];
    activeCaste.map((caste) =>
      data.push({
        cId: caste._id,
        label: caste.casteName,
        value: caste.casteName,
      }),
    );
    return data;
  }, [activeCaste]);

  const [caste, getCasteData] = useState();
  if (!caste && membersdata.memberCasteId && allCasteData.length > 0) {
    getCasteData(
      membersdata
        ? allCasteData &&
            allCasteData.filter((x) => x.cId === membersdata.memberCasteId)[0]
        : "",
    );
  }
  const [casteId, setCasteID] = useState(membersdata.memberCasteId);
  const [casteName, setCasteName] = useState(membersdata.memberCaste);
  const onCasteChange = (e) => {
    getCasteData(e);
    setCasteID(e.cId ? e.cId : null);
    setCasteName(e.value ? e.value : "");
    getSubcasteDetails({ cIdVal: e.cId });
    setSubCaste("");
    setSubCasteID(null);
    setSubCasteName("");
  };
  //SubOccupation START
  const allSubOccupation = useMemo(() => {
    let data = [];
    getAllSubOccupation &&
      getAllSubOccupation.map((subOccupation) =>
        data.push({
          subOccupationId: subOccupation._id,
          label: subOccupation.subOccupationName,
          value: subOccupation.subOccupationName,
        }),
      );
    return data;
  }, [getAllSubOccupation]);

  if (
    !membersubOccupation &&
    membersdata.memberSubOccupationId &&
    allSubOccupation.length > 0
  ) {
    setSubOccupation(
      membersdata
        ? allSubOccupation &&
            allSubOccupation.filter(
              (x) => x.subOccupationId === membersdata.memberSubOccupationId,
            )[0]
        : "",
    );
  }
  const [memberSubOccupationId, setSubOccupationID] = useState();
  // membersdata.memberSubOccupationId
  const [memberSubOccupationName, setSubOccupationName] = useState();
  // membersdata.memberSubOccupation
  const onSubOccupationChange = (e) => {
    setSubOccupation(e);
    setSubOccupationID(e.subOccupationId ? e.subOccupationId : null);
    setSubOccupationName(e.value ? e.value : "");
  };
  //SubOccupation  END
  //SubCaste START
  const allSubCaste = useMemo(() => {
    const data = [];
    getSubcaste.map((subCaste) =>
      data.push({
        subCasteId: subCaste._id,
        label: subCaste.subcasteName,
        value: subCaste.subcasteName,
      }),
    );
    return data;
  }, [getSubcaste]);
  const [subCaste, setSubCaste] = useState();
  if (!subCaste && membersdata.memberSubCasteId && allSubCaste.length > 0) {
    setSubCaste(
      membersdata
        ? allSubCaste &&
            allSubCaste.filter(
              (x) => x.subCasteId === membersdata.memberSubCasteId,
            )[0]
        : "",
    );
  }
  const [subCasteId, setSubCasteID] = useState(membersdata.memberSubCasteId);
  const [subCasteName, setSubCasteName] = useState(membersdata.memberSubCaste);
  const onSubCasteChange = (e) => {
    setSubCaste(e);
    setSubCasteID(e.subCasteId ? e.subCasteId : null);
    setSubCasteName(e.value ? e.value : "");
  };
  //SubCaste END
  //Family Religion
  const allFamilyReligionsData = useMemo(() => {
    const data = [];
    religionsData.map((religion) =>
      data.push({
        rId: religion._id,
        label: religion.religionName,
        value: religion.religionName,
      }),
    );
    return data;
  }, [religionsData]);
  const [familyReligion, getFamilyReligionData] = useState();
  const [familyReligionId, setFamilyReligionID] = useState();
  const [familyReligionName, setFamilyReligionName] = useState();
  const onFamilyReligionChange = (e) => {
    //Required Validation end
    getFamilyReligionData(e);
    setFamilyReligionID(e.rId ? e.rId : null);
    setFamilyReligionName(e.value ? e.value : "");
    getCaste({
      religionInfo: e.rId,
    });
    getFamilyCasteData("");
    setFamilyCasteID(null);
    setFamilyCasteName("");
    setFamilySubCaste("");
    setFamilySubCasteID(null);
    setFamilySubCasteName("");
  };
  //Family Caste
  const allFamilyCasteData = useMemo(() => {
    const data = [];
    activeCaste.map((caste) =>
      data.push({
        cId: caste._id,
        label: caste.casteName,
        value: caste.casteName,
      }),
    );
    return data;
  }, [activeCaste]);
  const [familyCaste, getFamilyCasteData] = useState();
  const [familyCasteId, setFamilyCasteID] = useState();
  const [familyCasteName, setFamilyCasteName] = useState();
  const onFamilyCasteChange = (e) => {
    getFamilyCasteData(e);
    setFamilyCasteID(e.cId ? e.cId : null);
    setFamilyCasteName(e.value ? e.value : "");
    getSubcasteDetails({ cIdVal: e.cId });
    setFamilySubCaste("");
    setFamilySubCasteID(null);
    setFamilySubCasteName("");
  };
  //Family Sub Caste
  const allFamilySubCaste = useMemo(() => {
    const data = [];
    getSubcaste.map((subCaste) =>
      data.push({
        subCasteId: subCaste._id,
        label: subCaste.subcasteName,
        value: subCaste.subcasteName,
      }),
    );
    return data;
  }, [getSubcaste]);
  const [batchId, setbatchId] = useState();
  const [batchFormationDate, setBatchFormationDate] = useState("");
  if (addBatchInfo && addBatchInfo[0] && addBatchInfo[0]._id && !batchId) {
    setbatchId(addBatchInfo[0] && addBatchInfo[0]._id);
    setBatchFormationDate(
      addBatchInfo[0] && addBatchInfo[0].batchFormationDate,
    );
  }

  var ED = batchFormationDate.split(/\D/g);

  var bFormationDate = [ED[2], ED[1], ED[0]].join("-");
  const [familySubCaste, setFamilySubCaste] = useState();
  const [familySubCasteId, setFamilySubCasteID] = useState();
  const [familySubCasteName, setFamilySubCasteName] = useState();
  const onFamilySubCasteChange = (e) => {
    setFamilySubCaste(e);
    setFamilySubCasteID(e.subCasteId ? e.subCasteId : null);
    setFamilySubCasteName(e.value ? e.value : "");
  };
  //CASTE RELIGION END
  if (isSubmitted) {
    return <Redirect to="/all-members" />;
  }
  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <div className="col-lg-11 col-md-11 col-sm-12 col-12">
          <h2 className="heading_color">Edit Member Details </h2>
          <hr />
        </div>
        <section className="sub_reg">
          <Tabs selectedIndex={tabIndex}>
            <div className="row col-lg-11 col-md-11 col-sm-12 col-12">
              <TabList>
                <Tab tabfor="0">Personal Info</Tab>
                {allPermission && allPermission.includes("Family") && (
                  <Tab tabfor="1">Family Details</Tab>
                )}
              </TabList>
            </div>
            <TabPanel tabId="0">
              <div className=" col-md-12 col-lg-12 col-sm-12 col-12 ">
                <form>
                  <div className="row col-lg-12 col-md-12 col-sm-12 col-12 ">
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12 py-3">
                      <div className="row card-new  py-3">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                          <h5>Personal Info</h5>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label
                            className="label-control"
                            style={MemErrorStyle}
                          >
                            Member Name* :
                          </label>
                          <input
                            type="text"
                            name="memberName"
                            value={memberName}
                            className="form-control"
                            onChange={(e) => {onInputChange(e);

                              setError({
                                  ...error,
                                  memberNameChecker: true,
                                  MemErrorStyle: { color: "#000" },
                                });

                            }}
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">


                          <label className="label-control"
                           style={phoneError}>
                            Member Phone*:
                          </label>
                          <input
                          type="text"
                          name="memberPhone"
                          value={memberPhone}
                          className="form-control"
                          maxLength={10}
                          onWheel={() => document.activeElement.blur()}
                          onChange={(e) => {
                            const value = e.target.value;
                          if (!/^\d*$/.test(value)) return;
                          onInputChange(e);
                        setError({
                              ...error,
                              phoneNumberChecker: true,
                              phoneError: { color: "#000" },
                            });
                          }}
                           onKeyDown={(e) => funcKeyDown(e)}
                          required
                        />
                          
                        </div>
                        {/* <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">
                            Member Religion :
                          </label>
                          <input
                            type="text"
                            name="memberReligion"
                            value={memberReligion}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                          />
                        </div> */}
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">Gender :</label>
                          <Select
                            name="memberGender"
                            options={GenderOpt}
                            isSearchable={false}
                            value={memberGender}
                            placeholder="Select Gender"
                            onChange={(e) => onRadioGenderChange(e)}
                          />
                          {/* <RadioGroup
                            // onChange={(e) => setSelectionType1(e)}
                            onChange={(e) => onRadioGenderChange(e)}
                            className="radio-group patient-page"
                            horizontal
                            value={selectionType1}
                            required
                          >
                            <RadioButton
                              padding={10}
                              rootColor="#144c5a"
                              pointColor="rgb(255,0,0)"
                              iconSize={20}
                              iconInnerSize={10}
                              value="M"
                            >
                              Male
                            </RadioButton>
                            <RadioButton
                              padding={10}
                              rootColor="#144c5a"
                              pointColor="rgb(255,0,0)"
                              iconSize={20}
                              iconInnerSize={10}
                              value="F"
                            >
                              Female
                            </RadioButton>
                          </RadioGroup> */}
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">
                            Ration Card Type :
                          </label>
                          <Select
                            name="rationCardType"
                            options={RationCardMethods}
                            isSearchable={false}
                            value={rationCardType}
                            placeholder="Select Ration Card Type"
                            onChange={(e) => onrationCardTypeChange(e)}
                          />
                        </div>
                        {/* <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">
                            Aadhaar Card No :
                          </label>
                          <input
                            type="text"
                            name="memberAadharNo"
                            value={memberAadharNo}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                          />
                        </div> */}
                        {allPermission &&
                        allPermission.includes("AadharNumber") ? (
                          <>
                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                              <label
                                className="label-control"
                                style={adharErrorStyle}
                              >
                                Aadhaar Card No* :
                              </label>
                              <input
                                type="text"
                                name="memberAadharNo"
                                value={memberAadharNo}
                                className="form-control"
                                onChange={(e) => onInputChange(e)}
                                required
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                              <label className="label-control">
                                Aadhaar Card No :
                              </label>
                              <input
                                type="text"
                                name="memberAadharNo"
                                value={memberAadharNo}
                                className="form-control"
                                onChange={(e) => onInputChange(e)}
                              />
                            </div>
                          </>
                        )}
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">Pan Card No :</label>
                          <input
                            type="text"
                            name="memberPanNo"
                            value={memberPanNo}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                          />
                        </div>
                        {allPermission &&
                          allPermission.includes("Disability") && (
                            <>
                              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                <label className="label-control">
                                  Have any disabilities? :
                                </label>
                                <input
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    borderRadius: "50%",
                                    display: "block",
                                  }}
                                  type="checkbox"
                                  id="Unconfirmed"
                                  checked={disabilitiesChecker}
                                  onChange={handleOnChange}
                                />
                              </div>
                              {disabilitiesChecker && (
                                <>
                                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                    <label
                                      className="label-control"
                                      style={DisabilityTypeErrorStyle}
                                    >
                                      Disability Type* :
                                    </label>

                                    <Select
                                      name="memberDisabilty"
                                      options={MemDisabilityList}
                                      isSearchable={false}
                                      value={memberDisabilityType}
                                      placeholder="Select"
                                      onChange={(e) => onMemDisabilityChange(e)}
                                      theme={(theme) => ({
                                        ...theme,
                                        height: 26,
                                        minHeight: 26,
                                        borderRadius: 1,
                                        colors: {
                                          ...theme.colors,
                                          primary: "black",
                                        },
                                      })}
                                    />
                                  </div>
                                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                    <label
                                      className="label-control"
                                      style={UDIDNumberErrorStyle}
                                    >
                                      UDID Number :
                                    </label>
                                    <input
                                      type="text"
                                      name="memberUdidNo"
                                      value={memberUdidNo}
                                      className="form-control"
                                      onChange={(e) => onInputChange(e)}
                                    />
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">
                            Health Vulnerability :
                          </label>
                          <Select
                            name="healthVulnerabilityType"
                            options={HealthVulnerability}
                            isSearchable={false}
                            value={healthVulnerabilityType}
                            placeholder="Select Health Vulnerability"
                            onChange={(e) => onHealthVulnerabilityTypeChange(e)}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                          <label className="label-control">
                            Contact Person Name :
                          </label>
                          <input
                            type="text"
                            name="memberContactPersonName"
                            value={memberContactPersonName}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                            required
                          />
                        </div>
                        {/* <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                          <label className="label-control">
                            Marital Status:
                          </label>
                          <input
                            type="text"
                            name="memberMaritalStatus"
                            value={memberMaritalStatus}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                            required
                          />
                        </div> */}
                        {allPermission &&
                        allPermission.includes("MemberPermission_AWAKE") ? (
                          <>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Marital Status&nbsp;:
                              </label>
                              <Select
                                name="memberMaritalStatus"
                                options={MemMaritalStatus}
                                isSearchable={false}
                                value={memberMaritalStatus}
                                placeholder="Select"
                                onChange={(e) => onMaritalStatusChange(e)}
                                theme={(theme) => ({
                                  ...theme,
                                  height: 26,
                                  minHeight: 26,
                                  borderRadius: 1,
                                  colors: {
                                    ...theme.colors,
                                    primary: "black",
                                  },
                                })}
                              />
                            </div>
                            {showmaritalothstatus && (
                              <>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                  <label className="label-control">
                                    Other status :
                                  </label>
                                  <input
                                    type="text"
                                    name="otherStatus"
                                    value={otherStatus}
                                    className="form-control"
                                    onChange={(e) => onInputChange(e)}
                                  />
                                </div>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Marital Status:
                              </label>
                              <input
                                type="text"
                                name="memberMaritalStatus"
                                value={memberMaritalStatus.value}
                                className="form-control"
                                onChange={(e) => onInputChange(e)}
                                required
                              />
                            </div>
                          </>
                        )}
                        {/* <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                          <label className="label-control">
                            Monthly Income :
                          </label>
                          <input
                            type="text"
                            name="memberMonthlyIncome"
                            value={memberMonthlyIncome}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                            required
                          />
                        </div> */}
                        {allPermission &&
                        allPermission.includes(
                          "MemberPermission_MonthlyIncome",
                        ) ? (
                          <>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Family Income :
                              </label>
                              <input
                                type="text"
                                name="memberMonthlyIncome"
                                value={memberMonthlyIncome}
                                className="form-control"
                                onChange={(e) => onInputChange(e)}
                                required
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Monthly Income :
                              </label>
                              <input
                                type="number"
                                name="memberMonthlyIncome"
                                value={memberMonthlyIncome}
                                className="form-control"
                                onChange={(e) => onInputChange(e)}
                                required
                              />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Annual Income :
                              </label>
                              <input
                                type="text"
                                name="memberAnnualIncome"
                                value={anualmemIncomeVal}
                                className="form-control"
                                onChange={(e) => onInputChange1(e)}
                                disabled
                              />
                            </div>
                          </>
                        )}
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                          <label className="label-control">
                            Vocational Skill :
                          </label>
                          <input
                            type="text"
                            name="memberVocationalSkill"
                            value={memberVocationalSkill}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                            required
                          />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-6 col-12">
                          <label className="label-control">Address :</label>
                          <textarea
                            name="memberAddress"
                            value={memberAddress}
                            id="memberAddress"
                            className="textarea form-control"
                            rows="4"
                            placeholder="Address"
                            onChange={(e) => onInputChange(e)}
                            style={{ width: "100%" }}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12 py-3">
                      <div className="row card-new py-3">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                          <h5>Other Info</h5>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">Member SHG :</label>
                          <input
                            type="text"
                            name="batchName"
                            value={batchName}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                            disabled
                          />
                        </div>
                        {allPermission &&
                          allPermission.includes("Occupation") && (
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Occupation :
                              </label>
                              <Select
                                name="memberOccupationName"
                                options={allOccupation}
                                isSearchable={true}
                                value={memberOccupation}
                                placeholder="Select Occupation"
                                onChange={(e) => onMemberOccupationChange(e)}
                                theme={(theme) => ({
                                  ...theme,
                                  height: 26,
                                  minHeight: 26,
                                  borderRadius: 1,
                                  colors: {
                                    ...theme.colors,
                                    primary: "black",
                                  },
                                })}
                              />
                            </div>
                          )}
                        {allPermission &&
                          allPermission.includes("Sub Occupation") && (
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Sub Occupation :
                              </label>
                              <Select
                                name="membersubOccupation"
                                options={allSubOccupation}
                                isSearchable={true}
                                value={membersubOccupation}
                                placeholder="Select Sub Occupation"
                                onChange={(e) => onSubOccupationChange(e)}
                                theme={(theme) => ({
                                  ...theme,
                                  height: 26,
                                  minHeight: 26,
                                  borderRadius: 1,
                                  colors: {
                                    ...theme.colors,
                                    primary: "black",
                                  },
                                })}
                              />
                            </div>
                          )}
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">Member Code :</label>
                          <input
                            type="text"
                            name="memberCode"
                            value={memberCode}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                            disabled
                          />
                        </div>
                        <div className="col-lg-6 col-md-7 col-sm-7 col-12">
                          <label className="label-control">
                            SHG Formation Date :
                          </label>
                          <input
                            type="text"
                            name="bFormationDate"
                            value={bFormationDate}
                            className="form-control"
                            onChange={(e) => onInputChange(e)}
                            disabled
                          />
                        </div>

                        <div className="col-lg-6 col-md-7 col-sm-7 col-12">
                          <label className="label-control">Joined Date :</label>
                          <input
                            type="date"
                            placeholder="dd/mm/yyyy"
                            className="form-control cpp-input datevalidation"
                            name="memberJoiningDate"
                            value={startSelectedDate}
                            onChange={(e) => onDateChange(e)}
                            style={{
                              width: "75%",
                            }}
                          />
                        </div>
                        {allPermission &&
                          allPermission.includes("Religion") && (
                            <>
                              <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                <label
                                  className="label-control"
                                  // style={DesgErrorStyle}
                                >
                                  Religion :
                                </label>
                                <Select
                                  name="memberReligion"
                                  options={allReligionsData}
                                  isSearchable={false}
                                  value={religion}
                                  placeholder="Select"
                                  onChange={(e) => onReligionChange(e)}
                                  theme={(theme) => ({
                                    ...theme,
                                    height: 26,
                                    minHeight: 26,
                                    borderRadius: 1,
                                    colors: {
                                      ...theme.colors,
                                      primary: "black",
                                    },
                                  })}
                                />
                              </div>
                              <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                <label
                                  className="label-control"
                                  // style={DesgErrorStyle}
                                >
                                  Caste :
                                </label>
                                <Select
                                  name="memberDesg"
                                  options={allCasteData}
                                  isSearchable={false}
                                  value={caste}
                                  placeholder="Select"
                                  onChange={(e) => onCasteChange(e)}
                                  theme={(theme) => ({
                                    ...theme,
                                    height: 26,
                                    minHeight: 26,
                                    borderRadius: 1,
                                    colors: {
                                      ...theme.colors,
                                      primary: "black",
                                    },
                                  })}
                                />
                              </div>
                              <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                <label
                                  className="label-control"
                                  // style={DesgErrorStyle}
                                >
                                  Sub Caste :
                                </label>
                                <Select
                                  name="memberDesg"
                                  options={allSubCaste}
                                  isSearchable={false}
                                  value={subCaste}
                                  placeholder="Select"
                                  onChange={(e) => onSubCasteChange(e)}
                                  theme={(theme) => ({
                                    ...theme,
                                    height: 26,
                                    minHeight: 26,
                                    borderRadius: 1,
                                    colors: {
                                      ...theme.colors,
                                      primary: "black",
                                    },
                                  })}
                                />
                              </div>
                            </>
                          )}
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label className="label-control">Designation :</label>
                          <Select
                            name="memberDesg"
                            options={MemDesigMethods}
                            isSearchable={false}
                            value={memberDesg}
                            placeholder="Select"
                            onChange={(e) => onMemDesigChange(e)}
                            theme={(theme) => ({
                              ...theme,
                              height: 26,
                              minHeight: 26,
                              borderRadius: 1,
                              colors: {
                                ...theme.colors,
                                primary: "black",
                              },
                            })}
                          />
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                          <label
                            className="label-control"
                            // style={DesgErrorStyle}
                          >
                            Education :
                          </label>
                          <Select
                            name="memberEducation"
                            options={EducationOpt}
                            isSearchable={false}
                            value={memberEducation}
                            placeholder="Select"
                            onChange={(e) => onMemmemberEducationChange(e)}
                            theme={(theme) => ({
                              ...theme,
                              height: 26,
                              minHeight: 26,
                              borderRadius: 1,
                              colors: {
                                ...theme.colors,
                                primary: "black",
                              },
                            })}
                          />
                        </div>
                        {showotherEducationSection && (
                          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                            <label className="label-control">
                              Other Education :
                            </label>
                            <input
                              type="text"
                              name="otherEducation"
                              value={otherEducation}
                              className="form-control"
                              onChange={(e) => onInputChange(e)}
                              required
                            />
                          </div>
                        )}
                        {allPermission &&
                          allPermission.includes("GovtCards") && (
                            <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                              <label className="label-control">
                                Govt Cards : &emsp;
                              </label>
                              <img
                                className="img_icon_size4 log underLine"
                                onClick={() => onClickHandler()}
                                src={require("../../static/images/cards.png")}
                                alt="Govt Cards"
                                title="Add Govt Cards"
                              />
                            </div>
                          )}
                      </div>
                      {allPermission && allPermission.includes("MemberAge") && (
                        <div className="row card-new py-3">
                          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <h5>Age Info</h5>
                          </div>
                          <div className="col-lg-6   col-md-7 col-sm-7 col-12">
                            <label className="label-control">
                              Date Of Birth* :
                            </label>
                            <input
                              type="date"
                              placeholder="dd/mm/yyyy"
                              className="form-control cpp-input datevalidation"
                              name="memberDOB"
                              value={memberDOB}
                              onChange={(e) => onDateChangeDOB(e)}
                              style={{
                                width: "75%",
                              }}
                              required
                            />
                          </div>
                          <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                            <label className="label-control">Age&nbsp;:</label>
                            <input
                              type="text"
                              name="memberAge"
                              value={memberAge}
                              className="form-control"
                              onChange={(e) => onInputChange(e)}
                              disabled
                            />
                          </div>
                          {memberAge < 18 && memberAge !== 0 && (
                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                              <label
                                className="label-control"
                                style={guardianNameErrorStyle}
                              >
                                Guardian Name :
                              </label>
                              <input
                                type="text"
                                name="guardianName"
                                value={guardianName}
                                className="form-control"
                                onChange={(e) => onInputChange(e)}
                                required
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      {allPermission && allPermission.includes("Family") ? (
                        <>
                          <input
                            type="button"
                            name="Next"
                            value="Next"
                            className="btn sub_form btn_continue Save float-right"
                            onClick={(e) => NextBackBtn(e, 1)}
                          />
                        </>
                      ) : (
                        <>
                          <input
                            type="submit"
                            name="submit"
                            value="Submit"
                            className="btn sub_form btn_continue Save float-right"
                            onClick={(e) => onUpdate(e)}
                          />
                        </>
                      )}
                      <Link
                        className="btn sub_form btn_continue Save float-right"
                        to="/all-members"
                        onClick={onUpdateModalChange}
                      >
                        Cancel
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </TabPanel>
            <TabPanel tabId="1">
              <form onSubmit={(e) => NextBackBtn(e, 2)}>
                <div className="row col-md-12 col-lg-12 col-sm-12 col-12 ">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12 py-3">
                    <div className="row card-new  py-3">
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <label className="label-control">
                          Family Member Name* :
                        </label>
                        <input
                          type="text"
                          name="familyMemberName"
                          value={familyMemberName}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                          required
                        />
                      </div>
                      <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                        <label className="label-control">
                          Family Member Phone :
                        </label>
                        <input
                          type="text"
                          name="familyMemberPhone"
                          value={familyMemberPhone}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                          required
                        />
                      </div>
                      <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                        <label className="label-control">
                          Family Member Age :
                        </label>
                        <input
                          type="text"
                          name="familyMemberAge"
                          value={familyMemberAge}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                          required
                        />
                      </div>
                      <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                        <label className="label-control">
                          Family Member Gender&nbsp;:
                        </label>
                        {/* <input
                          type="text"
                          name="familyMemberGender"
                          value={familyMemberGender}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                          required
                        /> */}
                        <Select
                          name="familyMemberGender"
                          options={GenderOpt}
                          isSearchable={false}
                          value={familyMemberGender}
                          placeholder="Select Gender"
                          onChange={(e) => onFamilyMemberGenderChange(e)}
                        />
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <label className="label-control">
                          Relationship to the Member :
                        </label>
                        <input
                          type="text"
                          name="familyMemberRelationship"
                          value={familyMemberRelationship}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                          required
                        />
                      </div>
                      <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                        <label className="label-control">
                          Marital status :
                        </label>
                        <input
                          type="text"
                          name="familyMemberMaritalStatus"
                          value={familyMemberMaritalStatus}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                          required
                        />
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <label className="label-control">Education :</label>
                        <Select
                          name="familyMemberEducation"
                          options={EducationOpt}
                          isSearchable={false}
                          value={familyMemberEducation}
                          placeholder="Select"
                          onChange={(e) => onFammemberEducationChange(e)}
                          theme={(theme) => ({
                            ...theme,
                            height: 26,
                            minHeight: 26,
                            borderRadius: 1,
                            colors: {
                              ...theme.colors,
                              primary: "black",
                            },
                          })}
                        />
                      </div>
                      {showFamOtherEducationSection && (
                        <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                          <label className="label-control">
                            Other Education :
                          </label>
                          <input
                            type="text"
                            name="otherFamilyEducation"
                            value={otherFamilyEducation}
                            className="form-control"
                            onChange={(e) => onInputChange1(e)}
                            required
                          />
                        </div>
                      )}
                      {allPermission &&
                        allPermission.includes("Occupation") && (
                          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                            <label className="label-control">
                              Occupation :
                            </label>
                            {/* <Autocomplete
                          suggestions={allOccupation}
                          setOcc={setOcc}
                          occ={occ}
                        /> */}
                            <Select
                              name="occupationName"
                              options={allOccupation}
                              isSearchable={true}
                              value={occupation}
                              placeholder="Select Occupation"
                              onChange={(e) => onOccupationChange(e)}
                              theme={(theme) => ({
                                ...theme,
                                height: 26,
                                minHeight: 26,
                                borderRadius: 1,
                                colors: {
                                  ...theme.colors,
                                  primary: "black",
                                },
                              })}
                            />
                          </div>
                        )}
                      {allPermission &&
                        allPermission.includes("Sub Occupation") && (
                          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                            <label className="label-control">
                              Sub Occupation :
                            </label>
                            <Select
                              name="familySubOccupation"
                              options={allSubOccupation}
                              isSearchable={true}
                              value={familySubOccupation}
                              placeholder="Select Sub Occupation"
                              onChange={(e) => onFamilySubOccupationChange(e)}
                              theme={(theme) => ({
                                ...theme,
                                height: 26,
                                minHeight: 26,
                                borderRadius: 1,
                                colors: {
                                  ...theme.colors,
                                  primary: "black",
                                },
                              })}
                            />
                          </div>
                        )}
                      <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                        <label className="label-control">
                          Monthly Income :
                        </label>
                        <input
                          type="number"
                          name="familyMemberMonthlyIncome"
                          value={familyMemberMonthlyIncome}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                        />
                      </div>
                      <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                        <label className="label-control">Annual Income :</label>
                        <input
                          type="text"
                          name="familyMemberAnnualIncome"
                          value={anualIncomeVal}
                          className="form-control"
                          onChange={(e) => onInputChange1(e)}
                          disabled
                        />
                      </div>
                      {allPermission && allPermission.includes("Religion") && (
                        <>
                          <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                            <label className="label-control">Religion :</label>
                            <Select
                              name="familyMemberReligion"
                              options={allFamilyReligionsData}
                              isSearchable={false}
                              value={familyReligion}
                              placeholder="Select"
                              onChange={(e) => onFamilyReligionChange(e)}
                              theme={(theme) => ({
                                ...theme,
                                height: 26,
                                minHeight: 26,
                                borderRadius: 1,
                                colors: {
                                  ...theme.colors,
                                  primary: "black",
                                },
                              })}
                            />
                          </div>
                          <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                            <label className="label-control">Caste :</label>
                            <Select
                              name="familyMemberCaste"
                              options={allFamilyCasteData}
                              isSearchable={false}
                              value={familyCaste}
                              placeholder="Select"
                              onChange={(e) => onFamilyCasteChange(e)}
                              theme={(theme) => ({
                                ...theme,
                                height: 26,
                                minHeight: 26,
                                borderRadius: 1,
                                colors: {
                                  ...theme.colors,
                                  primary: "black",
                                },
                              })}
                            />
                          </div>
                          <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                            <label className="label-control">Sub Caste :</label>
                            <Select
                              name="familyMemberSubCaste"
                              options={allFamilySubCaste}
                              isSearchable={false}
                              value={familySubCaste}
                              placeholder="Select"
                              onChange={(e) => onFamilySubCasteChange(e)}
                              theme={(theme) => ({
                                ...theme,
                                height: 26,
                                minHeight: 26,
                                borderRadius: 1,
                                colors: {
                                  ...theme.colors,
                                  primary: "black",
                                },
                              })}
                            />
                          </div>
                        </>
                      )}
                      {allPermission &&
                        allPermission.includes("Disability") && (
                          <>
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                              <label className="label-control">
                                Have any disabilities? :
                              </label>
                              <input
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  borderRadius: "50%",
                                  display: "block",
                                }}
                                type="checkbox"
                                checked={familyDisabilitiesChecker}
                                id="Unconfirmed"
                                onChange={handleOnFamilyChange}
                              />
                            </div>
                            {familyDisabilitiesChecker && (
                              <>
                                <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                  <label
                                    className="label-control"
                                    style={DisabilityTypeErrorStyle}
                                  >
                                    Disability Type* :
                                  </label>
                                  <Select
                                    name="familyMemberDisabilityType"
                                    options={MemDisabilityList}
                                    isSearchable={false}
                                    value={familyMemberDisabilityType}
                                    placeholder="Select"
                                    onChange={(e) => onFamDisabilityChange(e)}
                                    theme={(theme) => ({
                                      ...theme,
                                      height: 26,
                                      minHeight: 26,
                                      borderRadius: 1,
                                      colors: {
                                        ...theme.colors,
                                        primary: "black",
                                      },
                                    })}
                                  />
                                </div>
                                <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                  <label className="label-control">
                                    UDID Number* :
                                  </label>
                                  <input
                                    type="text"
                                    name="familyUdidNo"
                                    value={familyUdidNo}
                                    className="form-control"
                                    onChange={(e) => onInputChange1(e)}
                                  />
                                </div>
                              </>
                            )}
                          </>
                        )}
                      {allPermission && allPermission.includes("GovtCards") && (
                        <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                          <label className="label-control">
                            Govt Cards : &emsp;
                          </label>
                          <img
                            className="img_icon_size4 log underLine"
                            onClick={() => onFamilyClickHandler()}
                            src={require("../../static/images/cards.png")}
                            alt="Govt Cards"
                            title="Add Govt Cards"
                          />
                        </div>
                      )}
                      <div className="col-lg-12 col-md-6 col-sm-6 col-12">
                        <button
                          className="btn sub_form btn_continue Save"
                          onClick={(e) => onAdd(e)}
                        >
                          ADD
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12 py-3">
                    <div className="row card-new py-3">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className=" body-inner no-padding  table-responsive">
                          <table
                            className="tabllll table table-bordered table-striped table-hover"
                            id="datatable2"
                          >
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Age </th>
                                <th>Gender</th>
                                <th>Relationship</th>
                                <th>Marital status</th>
                                <th>Education</th>
                                <th>Other Education</th>
                                {allPermission &&
                                  allPermission.includes("Occupation") && (
                                    <th>Occupation </th>
                                  )}
                                {allPermission &&
                                  allPermission.includes("Sub Occupation") && (
                                    <th>Sub Occupation </th>
                                  )}
                                <th>Monthly Income</th>
                                <th>Annual Income</th>
                                {allPermission &&
                                  allPermission.includes("Religion") && (
                                    <>
                                      <th>Religion</th>
                                      <th>Caste</th>
                                      <th>Sub Caste</th>
                                    </>
                                  )}
                                {allPermission &&
                                  allPermission.includes("Disability") && (
                                    <>
                                      <th>Disability Type</th>
                                      <th>UDID Number</th>
                                    </>
                                  )}
                                {allPermission &&
                                  allPermission.includes("GovtCards") && (
                                    <>
                                      <th>Cards</th>
                                    </>
                                  )}
                                <th>Op</th>
                              </tr>
                            </thead>
                            <tbody>
                              {membersFamily &&
                                membersFamily.familyMembers &&
                                membersFamily.familyMembers.map(
                                  (famMembers, idx) => {
                                    // if (staff.staffStatus === "Active")
                                    return (
                                      <tr key={idx}>
                                        <td>{famMembers.familyMemberName}</td>
                                        <td>{famMembers.familyMemberPhone}</td>
                                        <td>{famMembers.familyMemberAge}</td>
                                        <td>{famMembers.familyMemberGender}</td>
                                        <td>
                                          {famMembers.familyMemberRelationship}
                                        </td>
                                        <td>
                                          {famMembers.familyMemberMaritalStatus}
                                        </td>
                                        <td>
                                          {famMembers.familyMemberEducation}
                                        </td>

                                        <td>
                                          {famMembers.otherFamilyEducation}
                                        </td>
                                        {allPermission &&
                                          allPermission.includes(
                                            "Occupation",
                                          ) && (
                                            <td>
                                              {famMembers.familyMemberOcupation}
                                            </td>
                                          )}
                                        {allPermission &&
                                          allPermission.includes(
                                            "Sub Occupation",
                                          ) && (
                                            <td>
                                              {
                                                famMembers.familyMemberSubOccupation
                                              }
                                            </td>
                                          )}
                                        <td>
                                          {famMembers.familyMemberMonthlyIncome}
                                        </td>
                                        <td>
                                          {famMembers.familyMemberAnnualIncome}
                                        </td>
                                        {allPermission &&
                                          allPermission.includes(
                                            "Religion",
                                          ) && (
                                            <>
                                              <td>
                                                {
                                                  famMembers.familyMemberReligion
                                                }
                                              </td>
                                              <td>
                                                {famMembers.familyMemberCaste}
                                              </td>
                                              <td>
                                                {
                                                  famMembers.familyMemberSubCaste
                                                }
                                              </td>
                                            </>
                                          )}
                                        {allPermission &&
                                          allPermission.includes(
                                            "Disability",
                                          ) && (
                                            <>
                                              <td>
                                                {
                                                  famMembers.familyMemberDisabilityType
                                                }
                                              </td>
                                              <td>{famMembers.familyUdidNo}</td>
                                            </>
                                          )}
                                        {allPermission &&
                                          allPermission.includes(
                                            "GovtCards",
                                          ) && (
                                            <td title={famMembers.familyCards}>
                                              <img
                                                className="img_icon_size log"
                                                src={require("../../static/images/info.png")}
                                                alt="Govt Cards"
                                                title={famMembers.familyCards}
                                              />
                                            </td>
                                          )}
                                        <td>
                                          <img
                                            className="img_icon_size log"
                                            onClick={() =>
                                              onUpdateFamilyDetails(
                                                famMembers,
                                                idx,
                                              )
                                            }
                                            src={require("../../static/images/edit_icon.png")}
                                            alt="Edit"
                                            title="Edit"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  },
                                )}
                              {AddedDetails &&
                                AddedDetails.map((AddDetail, idx) => {
                                  return (
                                    <tr key={idx}>
                                      <td>{AddDetail.familyMemberName}</td>
                                      <td>{AddDetail.familyMemberPhone}</td>
                                      <td>{AddDetail.familyMemberAge}</td>
                                      <td>{AddDetail.familyMemberGender}</td>
                                      <td>
                                        {AddDetail.familyMemberRelationship}
                                      </td>
                                      <td>
                                        {AddDetail.familyMemberMaritalStatus}
                                      </td>
                                      <td>{AddDetail.familyMemberEducation}</td>
                                      <td>{AddDetail.otherFamilyEducation}</td>
                                      {allPermission &&
                                        allPermission.includes(
                                          "Occupation",
                                        ) && (
                                          <td>
                                            {AddDetail.familyMemberOcupation}
                                          </td>
                                        )}
                                      {allPermission &&
                                        allPermission.includes(
                                          "Sub Occupation",
                                        ) && (
                                          <td>
                                            {
                                              AddDetail.familyMemberSubOccupation
                                            }
                                          </td>
                                        )}
                                      <td>
                                        {AddDetail.familyMemberMonthlyIncome}
                                      </td>
                                      <td>
                                        {AddDetail.familyMemberAnnualIncome}
                                      </td>
                                      {allPermission &&
                                        allPermission.includes("Religion") && (
                                          <>
                                            <td>
                                              {AddDetail.familyMemberReligion}
                                            </td>
                                            <td>
                                              {AddDetail.familyMemberCaste}
                                            </td>
                                            <td>
                                              {AddDetail.familyMemberSubCaste}
                                            </td>
                                          </>
                                        )}
                                      {allPermission &&
                                        allPermission.includes(
                                          "Disability",
                                        ) && (
                                          <>
                                            <td>
                                              {
                                                AddDetail.familyMemberDisabilityType
                                              }
                                            </td>
                                            <td>{AddDetail.familyUdidNo}</td>
                                          </>
                                        )}
                                      {allPermission &&
                                        allPermission.includes("GovtCards") && (
                                          <td title={AddDetail.familyCards}>
                                            <img
                                              className="img_icon_size log"
                                              src={require("../../static/images/info.png")}
                                              alt="Govt Cards"
                                              title={AddDetail.familyCards}
                                            />
                                          </td>
                                        )}
                                      <td>
                                        <img
                                          className="img_icon_size log"
                                          onClick={() =>
                                            onRemoveChange(
                                              AddDetail.familyMemberName,
                                            )
                                          }
                                          src={require("../../static/images/close-buttonRed.png")}
                                          alt="Remove"
                                          title="Remove"
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form className="row" onSubmit={(e) => onUpdate(e)}>
                <div className="col-lg-11 col-md-12 col-sm-12 col-12">
                  <input
                    type="submit"
                    name="Save"
                    value="Submit"
                    className="btn sub_form btn_continue Save float-right"
                  />
                  <button
                    className="btn sub_form btn_continue Save float-right"
                    onClick={(e) => NextBackBtn(e, 0)}
                  >
                    Previous
                  </button>
                </div>
              </form>
            </TabPanel>
          </Tabs>
          <Modal
            show={showEditModal}
            backdrop="static"
            keyboard={false}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header>
              <div className="col-lg-10">
                <h3 className="modal-title text-center">
                  Edit Family Member Details
                </h3>
              </div>
              <div className="col-lg-1">
                <button onClick={handleEditModalClose} className="close">
                  <img
                    src={require("../../static/images/close.png")}
                    alt="X"
                    style={{ height: "20px", width: "20px" }}
                  />
                </button>
              </div>
            </Modal.Header>
            <Modal.Body>
              <EditFamilyMember
                onEditModalChange={onEditModalChange}
                allFamMembersData={userFamMembersData}
                memberdata={membersdata}
              />
            </Modal.Body>
          </Modal>
          {showCardsModal && (
            <GovtCards
              showCardsModal={showCardsModal}
              handleCardsModalClose={handleCardsModalClose}
              setSelectedCards={setSelectedCards}
              SelectedCards={SelectedCards}
            />
          )}
          {showCardsFamilyModal && (
            <GovtCards
              showCardsModal={showCardsFamilyModal}
              handleCardsModalClose={handleCardsFamilyModalClose}
              setSelectedCards={setSelectedCardsFamily}
              SelectedCards={SelectedCardsFamily}
            />
          )}
          <div className="col-lg-12 col-md-6 col-sm-12 col-12">
            <label className="label-control colorRed">
              * Indicates mandatory fields, Please fill mandatory fields before
              Submit
            </label>
          </div>
        </section>
        <Modal
          show={showAlertMsg}
          backdrop="static"
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="logout-modal"
        >
          <Modal.Header className="confirmbox-heading">
            <h4 className="mt-0">Alert</h4>
          </Modal.Header>
          <Modal.Body>
            <h5>
              Please Select a Date which is greater than Batch Formation
              Date{" "}
            </h5>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn contact_reg "
              style={{ backgroundColor: "#144c5a" }}
              onClick={() => {
                onUpdateALertMsg();
              }}
            >
              OK
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </Fragment>
  );
};

EditMemberDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  editMember: PropTypes.object.isRequired,
  getOcccupationsDropdown: PropTypes.func.isRequired,
  getSubOccupation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  shg: state.shg,
  religionSetting: state.religionSetting,
});

export default connect(mapStateToProps, {
  editMember,
  getShgMembersFamily,
  addNewFamilyDetails,
  getShgMembersFamilyOccupation,
  getOcccupationsDropdown,
  getReligions,
  getCaste,
  getSubOccupation,
  getSubcasteDetails,
  getBatchInfo,
})(EditMemberDetails);
